import { useTranslation } from 'react-i18next'
import { quickActionConfigs } from './QuickActionsWidget.static'

export function useQuickActionsWidget() {
  const { t } = useTranslation('dashboard')

  const actions = quickActionConfigs.map((config) => ({
    ...config,
    label: t(config.labelKey),
  }))

  return { t, actions }
}
